// extracted by mini-css-extract-plugin
export default {"btnNav":"button_btnNav__zAZbp","icon":"button_icon__E4al2"};